import React from 'react';
import { ArrowRightIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

const TopicTestBanner = () => {
  const t = useTranslations();

  return (
    <div className="group my-28 overflow-hidden rounded-2xl bg-gradient-to-r from-[#162E76] to-[#169AA1] shadow-sm p-4 md:p-0">
      <div className="min-h-full md:min-h-120 relative flex max-w-screen items-center gap-10 text-white md:mx-auto md:grid md:grid-cols-2">
        <div className='md:px-10 px-0'>
          <p className="mb-3 font-medium">{t('nav.mavzuli_test')}</p>
          <h2 className="mb-6 text-2xl font-semibold lg:text-3xl">{t('turli_fanlar_boyicha_bilimlarni_sinovdan_otkazing')?.toUpperCase()}</h2>
          <p className="text-sm">{t('turli_fanlar_boyicha_bilimlarni_sinovdan_otkazing_desc')}</p>
          <div className="mt-10">
            <Link
              href={globalConst.pageNames.TOPIC_TEST}
              className="inline-flex font-medium items-center gap-1 text-sm rounded-lg border-none bg-white px-4 py-2  text-blue-600 hover:border-none"
            >
              {t('qaynoq_testlar')}
              <ArrowRightIcon />
            </Link>
          </div>
        </div>

        <div className="hidden md:block md:p-0">
          <div className="absolute -top-0 right-5 flex items-center justify-center">
            <div
              className="h-120 w-120 duration-400 z-0 flex items-center  justify-center rounded-full transition-transform group-hover:scale-110"
              style={{ backgroundColor: `#13779063` }}
            >
              <div className="duration-400 h-90 w-90 bg-radial z-0 flex items-center justify-center rounded-full from-white/10 to-[#137790E3] to-95% transition-transform group-hover:scale-110">
                <div
                  className="h-50 w-50 duration-400 z-0 rounded-full transition-transform group-hover:scale-110"
                  style={{ backgroundColor: `#137790E3` }}
                />
              </div>
            </div>
          </div>
          <div className="-right-30 rotate-y-165 -rotate-25 absolute -bottom-20 h-76 w-76 transition-transform duration-500 group-hover:rotate-[0deg]">
            <Image src="/images/geografiya.webp" fill alt="Geography globs" title="GLOBUS" />
          </div>
          <div className="top-27 h-63 w-63 absolute right-28 transition-transform duration-500 group-hover:scale-110">
            <Image src="/images/home-test.webp" fill alt="Test paper" title="Test varog'i" />
          </div>
          <div className="-rotate-23 absolute -bottom-10 right-80 h-40 w-40 transition-transform duration-500 group-hover:translate-y-[-10px]">
            <Image src="/images/book.webp" fill alt="Book" title="Kitob" />
          </div>
          <div className="right-75 absolute top-0 h-40 w-40 transition-transform duration-500 group-hover:scale-110">
            <Image
              src="/images/history-note.webp"
              className="scale-x-[-1]"
              fill
              alt="History Note"
              title="History varog'i"
            />
          </div>
          <div className="rotate-15 h-55 w-55 absolute -right-5 -top-10 transition-transform duration-500 group-hover:rotate-0">
            <Image src="/images/physics.webp" fill alt="History Note" title="History varog'i" />
          </div>
          <div className="right-15 rotate-15 w-21 h-21 absolute top-40 transition-transform duration-500 group-hover:rotate-0 group-hover:scale-110">
            <Image
              src="/images/chemistry.webp"
              fill
              className="blur-[2px]"
              alt="History Note"
              title="History varog'i"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopicTestBanner;
